<template>
  <div class="cart-holder">

    <h1>{{ t.cart_items }}</h1>

    <div id="webshop-cart-div" class="webshop-cart-block">

      <div v-if="productData.products_count">

        <div class="webshop-cart-desktop table-responsive">
          <table class="table">

            <tr class="table-top">
              <td colspan="6"></td>
              <td class="text-center product-header-h1 border-left border-right" v-if="productData.products_has_discount"><b>{{ t.discount }}</b></td>
              <td colspan="3"></td>
            </tr>

            <tr class="table-header">
              <th>&nbsp;</th>
              <th>&nbsp;</th>
              <th class="product-header-h2">{{ t.name }}</th>
              <th class="product-header-h2 text-right">{{ t.cut_sizes }}</th>
              <th class="product-header-h2 text-right">{{ t.quantity }}</th>
              <th class="product-header-h2 text-right">{{ t.unit_price }}</th>
              <th class="product-header-h2 text-right border-left" v-show="productData.products_has_discount">{{ t.unit_price }}</th>
              <th class="product-header-h2 text-right border-left">{{ t.net }}</th>
              <th class="product-header-h2 text-right">{{ t.vat }}</th>
              <th class="product-header-h2 text-right">{{ t.gross }}</th>
            </tr>
            <tr v-for="(p, pidx) in productData.products" v-bind:key="pidx">
              <td>
                <button type="button" class="btn btn-primary-small product-delete" data-opt="delete" :data-product="p.key" v-on:click="removeProduct">✖</button>
              </td>
              <td v-html="p.product_image" class="product-image"></td>
              <td v-html="p.name_url" class="product-url"></td>
              <td class="text-right product-size">{{ getSizeWithRemaind(p) }}</td>
              <td class="text-right product-unit_size">
                <input v-if="p.size=='-'" type="number" style="width: 58px;" v-model="p.quantity" :data-product="p.key" @change="setQuantity(p.quantity, $event)">
                <span v-if="p.size=='-'">{{ t.db }}</span>
                <span v-if="p.size=='-' && p.unit != t.db">, </span>
                <span v-if="p.size!='-' && p.unit != t.db">{{p.quantity}} {{t.db}}, </span>
                <span v-if="p.unit != t.db">{{ p.unit_size }}</span>

              </td>
              <td class="text-right product-net-unit">{{ formatNumber(p.net_unit_price) }} / {{p.unit}}</td>
              <td class="text-right product-net-unit-discount border-left" v-show="productData.products_has_discount"><span v-if="p.has_discount">{{ formatNumber(p.net_unit_discount_price) }} / {{p.unit}}</span></td>
              <td class="text-right product-net border-left">{{ formatNumber(p.net_price) }}</td>
              <td class="text-right product-tax">{{ formatNumber(p.tax_value) }}</td>
              <td class="text-right product-total">{{ formatNumber(p.gross_price) }}</td>
            </tr>

            <tr class="table-light">
              <td class="text-right product-bottom-h1" colspan="7" v-if="productData.products_has_discount"><b>{{ t.total_amount }}</b></td>
              <td class="text-right product-bottom-h1" colspan="6" v-if="!productData.products_has_discount"><b>{{ t.total_amount }}</b></td>
              <td class="text-right total-net border-left"><b>{{ formatNumber(productData.total.net) }}</b></td>
              <td class="text-right total-tax"><b>{{ formatNumber(productData.total.tax) }}</b></td>
              <td class="text-right total-total"><b>{{ formatNumber(productData.total.gross) }}</b></td>
            </tr>

          </table>
        </div>

        <div class="webshop-cart-mobile">
          <div class="cart-item-data" v-for="(p, pidx) in productData.products" v-bind:key="pidx">

            <div class="row">
              <div class="col-12 product-url-mobile">
                <button type="button" class="btn btn-primary-small product-delete" data-opt="delete" :data-product="p.key" v-on:click="removeProduct">✖</button>
                <div class="product-image" v-html="p.product_image"></div>
                <div class="product-name" v-html="p.name_url"></div>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.cut_sizes }}
              </div>
              <div class="col-6 text-left product-size-mobile">
                {{ p.size }}
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.quantity }}
              </div>
              <div class="col-6 text-left product-unit_size-mobile">
                <input v-if="p.size=='-'" type="number" style="width: 58px;" v-model="p.quantity" :data-product="p.key" @change="setQuantity(p.quantity, $event)">
                <span v-if="p.size=='-'">{{ t.db }}</span>
                <span v-if="p.size=='-' && p.unit != t.db">, </span>
                <span v-if="p.size!='-' && p.unit != t.db">{{p.quantity}} {{t.db}}, </span>
                <span v-if="p.unit != t.db">{{ p.unit_size }}</span>
              </div>
            </div>

            <div class="row product-item-line">
              <div class="col-6 text-left product-header-mobile">
                {{ t.unit_price }}
              </div>
              <div class="col-6 text-left product-net-unit-mobile">
                {{ formatNumber(p.net_unit_price) }}
              </div>
            </div>

            <div class="row" v-show="productData.products_has_discount">
              <div class="col-6 text-left product-header-mobile">
                {{ t.unit_price }}
              </div>
              <div class="col-6 text-left product-net-unit-discount-mobile">
                <span v-if="p.has_discount">{{ formatNumber(p.net_unit_discount_price) }}</span>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.net }}
              </div>
              <div class="col-6 text-left product-net-mobile">
                {{ formatNumber(p.net_price) }}
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.vat }}
              </div>
              <div class="col-6 text-left product-tax-mobile">
                {{ formatNumber(p.tax_value) }}
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-mobile">
                {{ t.gross }}
              </div>
              <div class="col-6 text-left product-total-mobile">
                {{ formatNumber(p.gross_price) }}
              </div>
            </div>

          </div>

          <div class="cart-item-total">

            <div class="row">
              <div class="col-12 product-total-header-mobile">{{ t.altogether }}</div>
            </div>

            <div class="row" v-if="productData.products_has_discount">
              <div class="col-6 text-left product-header-h1">
                {{ t.discount }}
              </div>
              <div class="col-6 text-left product-bottom-h1">
                <strong>{{ t.total_amount }}</strong>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-h1">
                {{ t.net }}
              </div>
              <div class="col-6 text-left total-net">
                <strong>{{ formatNumber(productData.total.net) }}</strong>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-h1">
                {{  t.vat }}
              </div>
              <div class="col-6 text-left total-tax">
                <strong>{{ formatNumber(productData.total.tax) }}</strong>
              </div>
            </div>

            <div class="row">
              <div class="col-6 text-left product-header-h1">
                {{ t.gross }}
              </div>
              <div class="col-6 text-left total-total">
                <strong>{{ formatNumber(productData.total.gross) }}</strong>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-if="!productData.products_count" class="alert alert-warning">{{ t.your_cart_is_empty }}</div>

    </div>

    <div class="webshop-step-holder">

      <div class="webshop-step-left">
        <div class="step-button">
          <a href="/webshop" class="btn btn-black-small text-red"><i class="fa fa-arrow-left" aria-hidden="true"></i> {{ t.back_to_webshop }}</a>
        </div>

        <div class="step-button" v-if="productData.products_count">
          <button class="btn btn-black-small text-red" v-on:click="emptyCart">{{ t.empty_cart }}</button>
        </div>
      </div>

      <div class="webshop-step-right" v-if="productData.products_count">
        <div class="step-button">
          <router-link :to="{ name: 'Customer' }"  v-if="userData.user_is_logged" class="btn btn-primary-small">
            {{ t.next }} <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </router-link>
        </div>
        <button v-if="!userData.user_is_logged" id="show-login-modal" class="btn btn-primary-small" data-toggle="modal" data-target="#login-modal">{{ t.next }} <i class="fa fa-arrow-right" aria-hidden="true"></i></button>

      </div>

    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import { buildCartGtmItems, pushEcommerceEvent } from '../gtm'

export default {
  name: 'Cart',
  computed: {
    ...mapGetters({
      t: "getLanguageData",
      productData: "getProductData",
      orderData: "getOrderData",
      userData: "getUserData",
    }),
  },
  methods:{
    pushViewCartEvent: function(){
      if(!this.productData.products_count){
        return;
      }

      pushEcommerceEvent('view_cart', {
        currency: String(this.orderData.currencyCode).toUpperCase(),
        value: Number(this.productData.total.gross),
        items: buildCartGtmItems(this.productData.products),
      });
    },
    getSizeWithRemaind: function (product){
      return product.size + (product.remainder_required?' '+this.t.with_remainder:'');
    },
    // Kosárból törlés
    removeProduct: function (e){
      let $this = this;

      let formData = {
        'page'        : 'Cart',
        'method'      : 'RemoveProduct',
        'product_id'  : e.target.dataset.product
      };

      $this.$store.dispatch('setData', formData);
    },

    // Kosár ürítése
    emptyCart: function (){
      let $this = this;

      let formData = {
        'page'        : 'Cart',
        'method'      : 'EmptyCart',
        'productData' : $this.productData
      };

      $this.$store.dispatch('setData', formData);
    },

    // Segéd függvény | Van többi oldalon is
    formatNumber: function (number){
      let formatter = new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: this.orderData.currencyCode,
        minimumFractionDigits: 0
      });

      return formatter.format(number);
    },
    setQuantity: function (quantity, e){
      if(quantity < 1){
        this.removeProduct(e);
      }else {
        let $this = this;
        let formData = {
          'page': 'Cart',
          'method': 'SetQuantity',
          'product_id': e.target.dataset.product,
          'quantity': quantity
        };
        $this.$store.dispatch('setData', formData);
      }
    },
  },
  beforeCreate() {
    this.$store.commit('setCurrentStep', 'Cart');
  },
  created() {
    this.pushViewCartEvent();
  },
}
</script>
